import type { Ref} from 'react';
import React from 'react';
import {mergeAttrs} from "../helpers/react-helpers";
import cn from 'classnames';

interface Props extends InputProps {
    focusRef?: Ref<HTMLInputElement>
}

export default class TextBox extends React.Component<Props> {
    render() {
        const {focusRef, ...props} = this.props;
        const attrs = mergeAttrs({
            type: 'text',
            className: cn('legacy-input', this.props.value ? 'not-empty' : 'empty'),
            ref: focusRef
        }, props);
        return <input {...attrs}/>;
    }
}
